/**
 * BeFrugal — automatic coupons and cash back
 *
 * A single web-accessible-resource group exposes a large set of paths — icons, the
 * AutoApplyResources UI, popup.html — to every origin, with no use_dynamic_url. Every
 * one sits at a fixed URL. The PNG icons load through an <img> with no CORS grant, so
 * they survive a restrictive page CSP; icon_cb.png is the cash-back badge.
 *
 * Manifest verified against version 2026.6.254.0.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'logldmlncddmdfcjaaljjjkajcnacigc';

export const beFrugal: ExtensionDefinition = {
  id: ID,
  name: 'BeFrugal: Automatic Coupons and Cash Back',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  notes:
    'Dozens of static WAR exposed to every origin with no dynamic URL. The icons load ' +
    'without a CORS grant and a popup.html fetch corroborates.',
  signals: [
    {
      id: 'war-icon-128',
      kind: 'web-accessible-resource',
      description:
        'Load icon128.png via <img> — exposed to every origin and readable without a ' +
        'CORS grant.',
      weight: 1,
      run: () => probeImage(ID, 'icon128.png'),
    },
    {
      id: 'war-icon-cb',
      kind: 'web-accessible-resource',
      description:
        'Load icon_cb.png via <img> — the cash-back badge, a second image path.',
      weight: 0.5,
      run: () => probeImage(ID, 'icon_cb.png'),
    },
    {
      id: 'war-popup-html',
      kind: 'web-accessible-resource',
      description: 'Fetch popup.html — the toolbar popup document, independent of the icons.',
      weight: 0.5,
      run: () => probeFetch(ID, 'popup.html'),
    },
  ],
};
